/**
 * Egyszer betöltött, közös (modulszintű) erőforrás: az összes komponens-példány
 * ugyanazt az egyetlen kérést / eredményt használja (pl. a terméklista minden
 * kártyája ugyanazt a készletkijelzés-beállítást). Hiba esetén a következő
 * `get()` újrapróbál; admin-mentés után `invalidate()`.
 */
export interface CachedResource<T> {
  get: () => Promise<T>;
  peek: () => T | undefined;
  invalidate: () => void;
}

export function cachedResource<T>(loader: () => Promise<T>): CachedResource<T> {
  let value: T | undefined;
  let pending: Promise<T> | null = null;

  const get = (): Promise<T> => {
    if (value !== undefined) return Promise.resolve(value);
    if (!pending) {
      pending = loader()
        .then((result) => {
          value = result;
          return result;
        })
        .finally(() => {
          pending = null;
        });
    }
    return pending;
  };

  return {
    get,
    peek: () => value,
    invalidate: () => {
      value = undefined;
      pending = null;
    },
  };
}
